import React, { useRef, useState } from "react";
import BannerSkeleton from "./Skeletons/BannerSkeleton.jsx";
import styled from "@emotion/styled";
import FavouriteButton from "./FavouriteButton.jsx";
import ShareButton from "./ShareButton.jsx";
import useDevice from "../hooks/useDevice.js";
import useMiniSite from "../hooks/useMiniSite.js";


const PictureWrapper = styled.picture`
  display: ${(props) => (props.isLoaded ? "block" : "none")};
`;

const EventBanner = ({
  bannerInfo: { playImage, alternateImage, facebookImage },
  title,
  loading,
}) => {
  const { isMobile } = useDevice();
  const [imgIsLoaded, setImgIsLoaded] = useState(false);
  const { isOlympiacos, isEmbedded, isPaoBC } = useMiniSite();

  let url = window.location.origin;

  let isMore =
    url.toLowerCase().indexOf("more") >= 0 &&
    url.toLowerCase().indexOf("in.more") === -1;

  const handleImageLoad = async (e) => {
    try {
      // Wait for the image to be fully decoded
      await e.target.decode();
      // Only then set it as loaded
      setImgIsLoaded(true);
    } catch {
      // If decode fails, still show the image
      setImgIsLoaded(true);
    }
  };

  return (
      <div className="r_banner" style={{ position: "relative" }}>
          {(loading || !imgIsLoaded) && <BannerSkeleton />}

          <div className="r_banner_img_container">
              <PictureWrapper isLoaded={imgIsLoaded}>
                  <source
                      media="(max-width:767px)"
                      srcSet={alternateImage || playImage}
                  />
                  <img src={playImage} alt={title} onLoad={handleImageLoad} />

                  <div
                      style={{
                          display: "flex",
                          position: "absolute",
                          top: isMobile ? 16 : 24,
                          right: isMobile ? 16 : 24,
                          gap: 16,
                      }}
                  >
                      {/* Hide favourite and share on the embedded experience
                          (hostname-based, so it applies both when the embedded URL is
                          loaded directly and when it is hosted in a parent iframe). */}
                      {isMore && !isWebView() && !isOlympiacos && !isEmbedded && !isPaoBC && <FavouriteButton />}
                      {!isEmbedded && <ShareButton title={title} banner={facebookImage} />}
                  </div>
              </PictureWrapper>
          </div>
      </div>
  );
};

export default EventBanner;
